import { useTranslation } from "react-i18next";
import { useAudioSettings } from "./useAudioSettings";

export function AudioControls() {
  const { t } = useTranslation();
  const {
    musicEnabled,
    effectsEnabled,
    toggleMusic,
    toggleEffects
  } = useAudioSettings();

  return (
    <div className="audio-controls" aria-label={t("audioControls")}>
      <button
        className="audio-control"
        type="button"
        aria-label={t(musicEnabled ? "turnMusicOff" : "turnMusicOn")}
        aria-pressed={musicEnabled}
        title={t(musicEnabled ? "turnMusicOff" : "turnMusicOn")}
        onClick={toggleMusic}
      >
        <MusicIcon muted={!musicEnabled} />
      </button>
      <button
        className="audio-control"
        type="button"
        aria-label={t(effectsEnabled ? "turnEffectsOff" : "turnEffectsOn")}
        aria-pressed={effectsEnabled}
        title={t(effectsEnabled ? "turnEffectsOff" : "turnEffectsOn")}
        onClick={toggleEffects}
      >
        <SpeakerIcon muted={!effectsEnabled} />
      </button>
    </div>
  );
}

function MusicIcon({ muted }: { muted: boolean }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9.5 17.2V6.8l9-2v9.4" />
      <path d="M9.5 14.8c-1.8-.7-4 .3-4.4 1.8-.4 1.3.7 2.5 2.3 2.6 1.7.1 2.6-.8 2.1-4.4ZM18.5 11.8c-1.8-.7-4 .3-4.4 1.8-.4 1.3.7 2.5 2.3 2.6 1.7.1 2.6-.8 2.1-4.4Z" />
      {muted ? <path className="audio-control__slash" d="m4 4 16 16" /> : null}
    </svg>
  );
}

function SpeakerIcon({ muted }: { muted: boolean }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4.5 9h4l4.7-3.8v13.6L8.5 15h-4Z" />
      {muted ? (
        <path className="audio-control__slash" d="m16 9 5 6m0-6-5 6" />
      ) : (
        <>
          <path d="M16 9.2a4 4 0 0 1 0 5.6" />
          <path d="M18.5 6.8a7.3 7.3 0 0 1 0 10.4" />
        </>
      )}
    </svg>
  );
}
